import { render, staticRenderFns } from "./detail_nb.vue?vue&type=template&id=39048ca5&"
import script from "./detail_nb.vue?vue&type=script&lang=js&"
export * from "./detail_nb.vue?vue&type=script&lang=js&"
import style0 from "./detail_nb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports